import getConversationSortByProperty from '../../../utils/tables/getConversationSortByProperty';
import MailFolderTableQuery from 'owa-mail-list-store/lib/store/schema/MailFolderTableQuery';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import { appendConversationWithSeekToConditionResponse } from 'owa-mail-list-response-processor';
import { findConversationWithSeekToInstanceKeyCondition } from 'owa-mail-store/lib/services/findConversationWithSeekToInstanceKeyCondition';
import { onLoadMoreRowsSucceeded, onLoadMoreRowsFailed } from '../onLoadMoreRowsCompleted';
import { getBaseFolderId, getBaseServerFolderId } from 'owa-mail-list-store';
import { getMailboxInfoFromTableQuery } from 'owa-mail-mailboxinfo';
import { LOAD_MORE_ROW_COUNT } from '../../data-loading/TableLoadingConstants';
import getHashtagsToInclude from 'owa-mail-inbox-plus-store/lib/selectors/getHashtagsToInclude';
import getHashtagsToExclude from 'owa-mail-inbox-plus-store/lib/selectors/getHashtagsToExclude';

/**
 * Load more conversations from the server
 * @param tableView to load
 */
export default function loadMoreConversationsFromServer(tableView: TableView) {
    const lastRowIndex = tableView.rowKeys.length - 1;
    const mailTableQuery = tableView.tableQuery as MailFolderTableQuery;

    // We always perform seek to condition request when we are loading more.
    // We use instancekey of the last item we have in the loaded rows in the table.
    // The seekToCondition ask server to get items from this instanceKey the response of which will also
    // include the last item who instanceKey we used.
    findConversationWithSeekToInstanceKeyCondition(
        getBaseFolderId(mailTableQuery),
        tableView.rowKeys[lastRowIndex],
        LOAD_MORE_ROW_COUNT,
        mailTableQuery.viewFilter,
        getConversationSortByProperty(mailTableQuery),
        mailTableQuery.focusedViewFilter,
        mailTableQuery.requestShapeName,
        getMailboxInfoFromTableQuery(mailTableQuery).requestOptions,
        mailTableQuery.categoryName,
        getHashtagsToInclude(mailTableQuery.inboxClassificationFilter),
        getHashtagsToExclude(mailTableQuery.inboxClassificationFilter),
        getBaseServerFolderId(tableView, true /* returnNullIfSameAsFolderId */)
    ).then(
        responseMessage => {
            if (responseMessage.ResponseClass === 'Success') {
                onLoadMoreRowsSucceeded(
                    tableView,
                    responseMessage.Conversations,
                    responseMessage.TotalConversationsInView,
                    appendConversationWithSeekToConditionResponse
                );
            } else {
                onLoadMoreRowsFailed(tableView, responseMessage.ResponseCode);
            }
        },
        (error: any) => {
            onLoadMoreRowsFailed(tableView);
        }
    );
}
